import { render, staticRenderFns } from "./CreateCar.vue?vue&type=template&id=041de748&"
import script from "./CreateCar.vue?vue&type=script&lang=js&"
export * from "./CreateCar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports